// extracted by mini-css-extract-plugin
module.exports = {"container":"_54f81e5","star":"_d6c3907","inverted":"_6c50801"};